import { apiUrl, authHeaders } from './auth';

export const createAccount = async (payload) => {
  const headers = authHeaders();
  const url = apiUrl + '/v2/accountSetup';
  const resp = await fetch(url, {
    method: 'POST',
    headers,
    body: JSON.stringify(payload),
  });
  const json = await resp.json();
  return json;
};

export const forgotPassword = async (email) => {
  const payload = {
    email,
  };
  const headers = authHeaders();
  const url = apiUrl + '/v2/forgot_password';
  const resp = await fetch(url, {
    method: 'POST',
    headers,
    body: JSON.stringify(payload),
  });
  const json = await resp.json();
  return json;
};

export const validatePasswordResetToken = async (token) => {
  const payload = {
    token,
  };
  const headers = authHeaders();
  const url = apiUrl + '/v2/validatePasswordResetToken';
  const resp = await fetch(url, {
    method: 'POST',
    headers,
    body: JSON.stringify(payload),
  });
  const json = await resp.json();
  return json;
};

export const validatePasswordResetTokenLegacy = async (token) => {
  const payload = {
    token,
  };
  const headers = authHeaders();
  const url = apiUrl + '/v2/validatePasswordResetTokenLegacy';
  const resp = await fetch(url, {
    method: 'POST',
    headers,
    body: JSON.stringify(payload),
  });
  const json = await resp.json();
  return json;
};

export const resetPassword = async (token, password) => {
  const payload = {
    token,
    password,
  };
  const headers = authHeaders();
  const url = apiUrl + '/v2/password_reset';
  const resp = await fetch(url, {
    method: 'POST',
    headers,
    body: JSON.stringify(payload),
  });
  const json = await resp.json();
  return json;
};

export const resetPasswordLegacy = async (token, password) => {
  const payload = {
    token,
    password,
  };
  const headers = authHeaders();
  const url = apiUrl + '/v2/password_reset_legacy';
  const resp = await fetch(url, {
    method: 'POST',
    headers,
    body: JSON.stringify(payload),
  });
  const json = await resp.json();
  return json;
};

export const putMyProfile = async (payload, campaignId) => {
  const headers = authHeaders();
  const baseUrl = apiUrl + '/v2/myProfile';
  const url = campaignId ? baseUrl + '?campaign_id=' + campaignId : baseUrl;
  const resp = await fetch(url, {
    method: 'PUT',
    headers,
    body: JSON.stringify(payload),
  });
  const json = await resp.json();
  return json;
};

export const setPassword = async (password) => {
  const headers = authHeaders();
  const url = apiUrl + '/auth/setPassword';
  const resp = await fetch(url, {
    method: 'POST',
    headers,
    body: JSON.stringify({ password }),
  });
  const json = await resp.json();
  return json;
};
